module.exports = {"371771001":"丹阳街道","371771002":"岳程街道","371771003":"佃户屯街道办"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371771.json
// module id = 1511
// module chunks = 0